import { cn } from 'cn';

import { Button, Icon } from '@vestigas/ui';

type FiltersDrawerFooterProps = {
  readonly canSave: boolean;
  readonly hasSavedFiltersEnabled: boolean;
  readonly isDirty: boolean;
  readonly isSavePending: boolean;
  readonly resetText: string;
  readonly saveText: string;
  readonly searchText: string;
  readonly onReset: () => void;
  readonly onSave: () => void;
  readonly onSearch: () => void;
};

export function FiltersDrawerFooter({
  canSave,
  hasSavedFiltersEnabled,
  isDirty,
  isSavePending,
  resetText,
  saveText,
  searchText,
  onReset,
  onSave,
  onSearch,
}: FiltersDrawerFooterProps) {
  return (
    <footer className="sticky bottom-0 flex shrink-0 flex-col gap-2 bg-white/90 px-5 py-4 backdrop-blur-sm">
      <div
        className={cn({
          'grid grid-cols-2 gap-2': hasSavedFiltersEnabled,
        })}
      >
        <Button
          buttonStyle="secondary"
          className="w-full justify-center"
          disabled={!isDirty || isSavePending}
          text={resetText}
          type="button"
          onClick={onReset}
        />
        {hasSavedFiltersEnabled ? (
          <Button
            buttonStyle="secondary"
            className="w-full justify-center"
            disabled={!canSave || isSavePending}
            loading={isSavePending}
            text={saveText}
            type="button"
            onClick={onSave}
          />
        ) : null}
      </div>
      <Button
        buttonStyle="primary"
        className="w-full justify-center"
        icon={<Icon metaphor="search" size="inherit" />}
        text={searchText}
        type="button"
        onClick={onSearch}
      />
    </footer>
  );
}
